import { api } from './client';

export interface AuditRecord {
  ts: string;
  user: string;
  action: string;
  target?: string;
  result: 'attempt' | 'success' | 'failure';
  ip?: string;
  duration_ms?: number;
}

export interface AuditQuery {
  limit?: number;
  offset?: number;
  user?: string;
  action?: string;
  result?: string;
  from?: string;
  to?: string;
}

export interface AuditResponse {
  entries: AuditRecord[];
  total: number;
}

export const fetchAudit = (q: AuditQuery): Promise<AuditResponse> =>
  api.get<AuditResponse>('/audit', { params: q }).then((r) => r.data);

export function auditCsvUrl(q: Omit<AuditQuery, 'limit' | 'offset'>): string {
  const params = new URLSearchParams();
  if (q.user)   params.set('user', q.user);
  if (q.action) params.set('action', q.action);
  if (q.result) params.set('result', q.result);
  if (q.from)   params.set('from', q.from);
  if (q.to)     params.set('to', q.to);
  const qs = params.toString();
  return `/api/audit/export.csv${qs ? `?${qs}` : ''}`;
}
